// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages
import { ChooseRoleDialogComponent } from 'src/app/modules/auth/components/choose-role-dialog/choose-role-dialog.component';
import { LoginComponent } from 'src/app/modules/auth/pages/login/login.page';
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.page';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    AuthRoutingModule,
    PublicModule,
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ChooseRoleDialogComponent,
  ],
  entryComponents: [
    ChooseRoleDialogComponent,
  ],
  exports: [
  ]
})
export class AuthModule { }
